import React from "react";
import PropTypes from "prop-types";
import { classNames } from "../../utils";

export const ICON_NAME = /** @type { const } */ ([
  "checked",
  "uncheck",
  "triangle-up",
  "triangle-down",
  "arrow-right",
  "arrow-left",
  "arrow-down",
  "arrow-up",
  "loading",
  "chevron-down",
  "close",
  "rectangle",
  "checkbox-active",
  "light-checkbox",
  "checkbox",
  "print",
  "pdf",
  "excel",
  "stack-chart",
  "line-chart",
  "axis-line-chart",
  "thin-column-chart",
  "union"
]);
/**
 *
 * @param {{
 * className: string,
 * name: import("../../..").ArrayToTuple<typeof ICON_NAME>
 * }} props
 */
export default function Icon({ name, className, ...props }) {
  return <span className={classNames(`fs-${name}`, className, "fs-icon")} {...props}></span>;
}

Icon.propTypes = {
  name: PropTypes.oneOf(ICON_NAME),
  className: PropTypes.string,
};
